import i18next from "i18next";
import { roles, translationConstants } from "../../../../constants";

export const getInstructorType = (userInfo, centerId) =>
  userInfo.role === roles.FreelanceInstructor
    ? translationConstants.instructorRoleFreelance
    : userInfo.role === roles.Instructor && centerId
    ? translationConstants.instructorRoleCenter
    : translationConstants.instructorRoleNone;

export const getInstructorTypeOptions = (t) => {
  return [
    { id: "", value: "", label: t(translationConstants.TYPE) },
    { id: 1, value: "Center", label: t(translationConstants.CENTER) },
    { id: 2, value: "None", label: t(translationConstants.NONE) },
    { id: 3, value: "Freelance", label: t(translationConstants.FREELANCE) },
  ];
};

export const getExportHeaders = (columns) =>
  columns
    .filter((x) => x.id !== "actions" && x.id !== "isActive")
    .map((h) => ({ label: h.name, key: h.accessor }));

export const getDataToExport = (data) =>
  data.map((x) => ({
    ...x,
    arabicFullName: `${x.userInfo.arabicFirstName || ""} ${
      x.userInfo.arabicLastName || ""
    }`,
    fullName: `${x.userInfo.englishFirstName} ${x.userInfo.englishLastName}`,
    type: i18next.t(getInstructorType(x.userInfo, x.centerId)),
  }));
